export default [
  {
    id: 'event',
    name: 'Match fees',
  },
  {
    id: 'registration',
    name: 'Registration',
  },
  {
    id: 'forfeit',
    name: 'Forfeit fees',
  },
  {
    id: 'other',
    name: 'Other',
  },
];
